module.exports = __webpack_public_path__ + "static/add-meiyu-qrcode.ja-afacfdbc0f7e310a6355a84d8a213bf1.svg";